angular.module('tc.lookup')

/**
* @ngdoc service
* @name tcApp.service:lookupService
* @description
* Handles general, non-presentation related lookup behaviour
*/

.factory('lookupService', function(SystemRouter, $q, $log) {
	// Return an object containing the parameters required to request lookup data from cache
	var prepareLookupParams = function(queryMethodArguments, componentItemName, lookupInput,
															componentController, listRowIndex, isEmbeddedLookup) {
		var params = {};
		if (angular.isUndefined(queryMethodArguments) || queryMethodArguments == '') {
			if ((angular.isDefined(isEmbeddedLookup)) && (isEmbeddedLookup) && (lookupInput !== '')) {
				angular.extend(params, addListboxLookupParam(lookupInput));
			}
			return params;
		}
		
		var splitArguments;
		// Process each of the arguments cache tells us we need to include in the request
		if (angular.isArray(queryMethodArguments)) {
			splitArguments = queryMethodArguments;
		} else {
			splitArguments = queryMethodArguments.split(',');
		}
		for (var i = 0; i < splitArguments.length; i++) {
			var paramKey = 'P' + (i + 1);
			params['TPARAMCOUNT'] = (i + 1);
			var currentArgument = splitArguments[i];
			
			var firstChar = currentArgument[0];
			if (firstChar == '\'' || firstChar == '"') {
				// arguments that are wrapped in quotes are passed as strings
				// Strip quotes from the start/end of the string
				params[paramKey] = currentArgument.replace(/(^'|^"|'$|"$)/g, '');
			} else if (firstChar === '&') {
				// arguments beginning with '&' refer to other component items on the same list row
				currentArgument = currentArgument.substr(1, currentArgument.length - 1); // strip '&' first
				if (componentItemName == (currentArgument + 'z' + (listRowIndex + 1))) {
					params[paramKey] = lookupInput;
					// Used to indicate the parameter that is the input value, so determine whether to run the broker
					params['TBROKERPARAM'] = paramKey;
				} else if (angular.isDefined(componentController.componentListRows[listRowIndex][currentArgument])) {
					params[paramKey] = componentController.componentListRows[listRowIndex][currentArgument].value;
				} else {
					params[paramKey] = '';
				}
			} else if (componentItemName === currentArgument) {
				// Where parameter is the current field name, just use the input value
				params[paramKey] = lookupInput;
				params['TBROKERPARAM'] = paramKey;
			} else if (angular.isDefined(componentController.componentItems[currentArgument])) {
				// If it's another component item, use the value from the lookup's controller's $scope.data
				params[paramKey] = componentController.componentItems[currentArgument].value;
			} else {
				// Default to empty string
				params[paramKey] = '';
			}
			// TC UI passes string literals 'true'/'false' for checkbox values
			// (Note this is different to form submission values 'on'/'')
			if (params[paramKey] === true) params[paramKey] = 'true';
			if (params[paramKey] === false) params[paramKey] = 'false';
		}
		if ((angular.isDefined(isEmbeddedLookup)) && (isEmbeddedLookup) && (lookupInput !== '') 
		&& (angular.isUndefined(params['TBROKERPARAM']))) {
			angular.extend(params, addListboxLookupParam(lookupInput));
		}

		var lookupItem;
		if (angular.isDefined(componentController.componentItems[componentItemName])) {
			lookupItem = componentController.componentItems[componentItemName];
		} else if (angular.isDefined(listRowIndex) && (angular.isDefined(componentController.componentListRows[listRowIndex]))
					&& (angular.isDefined(componentController.componentListRows[listRowIndex][componentItemName]))) {
			lookupItem = componentController.componentListRows[listRowIndex][componentItemName];
		}
		if (lookupItem) {
			angular.extend(params, getExtendedLookupParams(lookupItem, listRowIndex, componentController));
		}
		return params;
	};
	
	/// for non lookup-to-listbox query, add the field value for generic filtering
	var addListboxLookupParam = function(lookupInput) {
		var listboxParam = {};
		var paramKey = 'TLOOKUPLISTBOXSEARCH';
		listboxParam[paramKey] = lookupInput;
		listboxParam['TBROKERPARAM'] = paramKey;
		return listboxParam;
	};
	
	/// Return an object containing the extended lookup parameters added via custom calls of tkLib().extendLookup()
	var getExtendedLookupParams = function(lookupItem, listRowIndex, componentController) {
		var params = {};
		if (!lookupItem) return params;
		if (angular.isUndefined(lookupItem.extendedLookupParams)) return params;
		
		var paramCount = 0;
		angular.forEach(lookupItem.extendedLookupParams, function(param) {
			paramCount++;
			var paramKey = ('PX_' + paramCount);
			if (angular.isString(param)) {
				params[paramKey] = param;
			} else if (angular.isObject(param)) {
				if (angular.isDefined(param.name) && (param.name !== '')) {
					paramKey = 'PX_' + param.name;
				}
				if (angular.isDefined(param.value)) {
					params[paramKey] = param.value;
				} else if (angular.isDefined(param.itemName)) {
					var itemName = param.itemName;
					if ((itemName[0] === '&') && (angular.isDefined(listRowIndex))) {
						itemName = itemName.slice(1);
						if (angular.isDefined(componentController.componentListRows[listRowIndex][itemName])) {
							params[paramKey] = componentController.componentListRows[listRowIndex][itemName].value;
						}
					} else if (angular.isDefined(componentController.componentItems[itemName])) {
						params[paramKey] = componentController.componentItems[itemName].value;
					}
					if ((angular.isDefined(params[paramKey])) && (params[paramKey] === true)) params[paramKey] = 'true';
					if ((angular.isDefined(params[paramKey])) && (params[paramKey] === false)) params[paramKey] = 'false';
				}
			}
		});
		return params;
	};
	
	// Makes a request to cache to fetch lookup data, processes the response for the lookup directive/template
	var lookup = function(pageNumber, classQueryName, lookupRequestParams,
							brokerMethodName, componentContext, dynamicFavourites, componentItem, maxRows) {
		var promise = $q(function(resolve, reject) {
			// Fetch the lookup data from cache
			SystemRouter.fetchLookupData(pageNumber, classQueryName, lookupRequestParams,
										brokerMethodName, componentContext, dynamicFavourites, componentItem, maxRows)
			.then(function(successData) {
				// Grab the relevant parts of the data
				var responseData = successData.data;
				var lookupData = {
					headers: [],
					rows: [],
					listPageCount: null,
					listMoreRows: null,
					error: null,
				};
				
				if (angular.isDefined(responseData.error)) {
					lookupData['error'] = responseData.error;
					$log.error('Error retrieving lookup data on server:', responseData);
					if (angular.isDefined(responseData.layoutPickerUrl)) {
						lookupData['layoutPickerUrl'] = responseData.layoutPickerUrl;
					}
				} else {
					// Get the matches
					var matches = [];
					var match;
					for (var i = 0; i < responseData.listRows.length; i++) {
						var row = responseData.listRows[i];
						// Join row values with "^"
						var rowData = row.map(function(row) { return row.value; }).join('^');
						match = {
							cols: row,
							model: row[0].value,
							data: rowData,
							isFavourite: row[0].isFavourite,
							valueId: row[0].valueId
						};
						if (((angular.isUndefined(match.valueId)) || (match.valueId === '')) && (row.length > 1)) {
							angular.extend(match, {valueId: row[1].value});
						}
						// Set up an object indexed by column name for use in custom template
						var colsNamed = {};
						angular.forEach(row, function(col, colIndex) {
							var header = responseData.listHeaders[colIndex];
							if ((header) && (header.name !== '')) {
								colsNamed[header.name] = col;
							}
						});
						match.colsNamed = colsNamed;
						matches.push(match);
					}
					lookupData['rows'] = matches;
					
					// Get the other headers, page count, and paging
					if (angular.isDefined(responseData.listHeaders)) lookupData['headers'] = responseData.listHeaders;
					if (angular.isDefined(responseData.listHeadersNamed)) lookupData['headersNamed'] = responseData.listHeadersNamed;
					if (angular.isDefined(responseData.listPageCount)) lookupData['listPageCount'] = responseData.listPageCount;
					if (angular.isDefined(responseData.listMoreRows)) lookupData['listMoreRows'] = responseData.listMoreRows;
					if (angular.isDefined(responseData.hasBrokerResult)) lookupData['hasBrokerResult'] = responseData.hasBrokerResult;
					if (angular.isDefined(responseData.hadBrokerShown)) lookupData['hadBrokerShown'] = responseData.hadBrokerShown;
					if (angular.isDefined(responseData.layoutPickerUrl)) lookupData['layoutPickerUrl'] = responseData.layoutPickerUrl;
					if (angular.isDefined(responseData.monitor)) lookupData['monitor'] = responseData.monitor;
					if (angular.isDefined(responseData.customTemplateUrl)) {
						lookupData['customTemplateUrl']	= responseData.customTemplateUrl;
					}
					if (angular.isDefined(responseData.modelClassName)) lookupData['modelClassName'] = responseData.modelClassName;
				}
				resolve(lookupData);
			}, function(responseData) {
				$log.error('Error retrieving lookup data:', responseData);
				reject(responseData);
			});
		});
		return promise;
	};
	
	return {
		prepareLookupParams: prepareLookupParams,
		lookup: lookup,
	};
});
